import React from 'react';
import { Page, LayoutComposer } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import LoginPage from '../../components/login/LoginPage';
import css from './FactoryLoginPage.module.css';

const layoutAreas = `
  topbar
  main
  footer
`;

/**
 * FactoryLoginPage
 * Common login page for all user types (factory, agent, customer).
 * Rendered at /login route.
 */
const FactoryLoginPage = () => {
  return (
    <Page title="Login | ChinaDolphins" scrollingDisabled={false}>
      <LayoutComposer areas={layoutAreas} className={css.layout}>
        {({ Topbar, Main, Footer }) => (
          <>
            <Topbar as="header" className={css.topbar}>
              <TopbarContainer currentPage="LoginPage" />
            </Topbar>
            <Main as="main" className={css.main}>
              <LoginPage />
            </Main>
            <Footer>
              <FooterContainer />
            </Footer>
          </>
        )}
      </LayoutComposer>
    </Page>
  );
};

export default FactoryLoginPage;
